import Script from "next/script";

export default function Subscribe() {
  return (
    <section className="grid lg:grid-cols-2 text-center lg:text-left justify-center items-center w-full max-w-7xl mx-auto pt-8 lg:h-[calc(100vh-10rem)]">
      <link
        rel="stylesheet"
        href="https://sibforms.com/forms/end-form/build/sib-styles.css"
      />
      <div className="space-y-2 px-8 text-gray-900 max-w-xl">
        <p className="font-semibold text-sm">Newsletter</p>
        <h1 className="text-4xl font-bold">Subscribe For The Datopianist.</h1>
        <p className="font-semibold text-sm">
          More than 10,000 people have joined the Datopianist—the official
          newsletter of Datopian. Enter your email and get the latest and
          greatest in data, special offers, exclusive news, and a sneak peek
          into new products and services. Delivered to your inbox monthly.
        </p>
      </div>
      <div className="sib-form max-w-2xl lg:max-w-5xl !font-['Inter'] !px-8">
        <div id="sib-form-container" className="!mt-8">
          <div
            id="error-message"
            className="sib-form-message-panel !w-fit !m-0 !mt-4 text-base text-left text-[#661d1d] bg-[#ffeded] border border-[#ff4949] rounded"
          >
            <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
              <svg
                viewBox="0 0 512 512"
                className="sib-icon sib-notification__icon"
              >
                <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
              </svg>
              <span className="sib-form-message-panel__inner-text">
                Your subscription could not be saved. Please try again.
              </span>
            </div>
          </div>
          <div
            id="success-message"
            className="sib-form-message-panel !w-fit !m-0 !mt-4 text-base text-left text-[#085229] bg-[#e7faf0] border border-[#13ce66] rounded"
          >
            <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
              <svg
                viewBox="0 0 512 512"
                className="sib-icon sib-notification__icon"
              >
                <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
              </svg>
              <span className="sib-form-message-panel__inner-text">
                Your subscription has been successful!
              </span>
            </div>
          </div>
          <form
            id="sib-form"
            method="POST"
            action="https://0613d040.sibforms.com/serve/MUIEAKfRo-lO46VJlQJ-1kVozCMQ0S_5S2gdVtBTlUlEjP20NVpOEB51v1hXi3E3WbALTojbhLXtePha3kA3eY7oOtyVCc9pbGx5EG4-GTBhbCZUiOgOqM7oZl5l9JoL77yVQD168dfbpoMFpOcLnjrFeWfTTUU2SOdw2Pa6IDib71CTkWsBIKW3LjqOqDfQ4rxxIZ4g4BCRoaq8"
            data-type="subscription"
            className="flex flex-col lg:items-baseline mx-auto space-y-2 lg:space-x-4 max-w-md"
          >
            <div className="sib-input sib-form-block !p-0 lg:flex-1 w-full">
              <div className="form__entry entry_block">
                <div className="entry__field w-full">
                  <input
                    className="input !text-black !text-lg !px-4 !py-1 w-full placeholder:!text-gray-400 placeholder:!text-sm  placeholder:!text-lg"
                    maxLength={200}
                    type="text"
                    id="FIRSTNAME"
                    name="FIRSTNAME"
                    placeholder="Your name"
                    autoComplete="off"
                    data-required="true"
                    title="First name"
                    required=""
                  />
                </div>
                <label className="entry__error entry__error--primary !max-w-full !text-sm text-left bg-[#ffeded] border-[#ff4949] rounded-md"></label>
              </div>
            </div>
            <div className="sib-input sib-form-block !p-0 w-full lg:flex-1">
              <div className="form__entry entry_block">
                <div className="entry__field w-full">
                  <input
                    className="input !text-black !text-lg !px-4 !py-1 w-full placeholder:!text-gray-400 placeholder:!text-sm  placeholder:!text-lg"
                    type="text"
                    id="EMAIL"
                    name="EMAIL"
                    title="Email"
                    placeholder="Your email address"
                    autoComplete="off"
                    data-required="true"
                    required
                  />
                </div>
                <label className="entry__error entry__error--primary !max-w-full !text-sm text-left bg-[#ffeded] border-[#ff4949] rounded-md"></label>
              </div>
            </div>
            {/* recaptcha */}
            <div
              className="g-recaptcha !w-0"
              data-sitekey="6LfnC1IkAAAAAF2e32Omr3Vh-_byMLrtYhpv98pm"
              data-callback="invisibleCaptchaCallback"
              data-size="invisible"
              onClick="executeCaptcha"
            />
            <button
              className="sib-form-block__button sib-form-block__button-with-loader relative w-full lg:w-fit lg:!m-0 text-lg text-white font-normal bg-orange-400 hover:bg-orange-600 border-0 rounded-md"
              form="sib-form"
              type="submit"
              aria-label="Subscribe"
            >
              <svg
                className="icon clickable__icon progress-indicator__icon sib-hide-loader-icon absolute left-1/3 !m-0 h-6"
                viewBox="0 0 512 512"
              >
                <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
              </svg>
              Subscribe
            </button>
            <input
              type="text"
              name="email_address_check"
              defaultValue=""
              className="hidden"
            />
            <input type="hidden" name="locale" defaultValue="en" />
          </form>
        </div>
        <Script
          id="landing-form-validation-message"
          dangerouslySetInnerHTML={{
            __html: `
            window.LOCALE = 'en';
            window.EMAIL_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";

            window.REQUIRED_ERROR_MESSAGE = "This field cannot be left blank. ";

            window.GENERIC_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";

            window.translation = {
              common: {
                selectedList: '{quantity} list selected',
                selectedLists: '{quantity} lists selected'
              }
            };

            var AUTOHIDE = Boolean(0);
          `,
          }}
        />
        <Script
          id="submit-landing-form"
          src="https://sibforms.com/forms/end-form/build/main.js"
        />
        <Script
          id="landing-form-recaptcha"
          src="https://www.google.com/recaptcha/api.js?hl=en"
        />
      </div>
    </section>
  );
}
